import { Fragment } from "react";

import useOrgUnitAdminRelayEntriesTeams from "./UseOrgUnitAdminRelayEntriesTeams";

import OrgUnitAdminRelayEntriesTeamsGrid from "./OrgUnitAdminRelayEntriesTeamsGrid";

import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import ActionIntraPageButton from "@usas/ui-web/components/buttons/ActionIntraPageButton";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import Constants from "@usas/ui-web/utils/Constants";
import ToIntIfInt from "@usas/ui-web/utils/ToIntIfInt";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const OrgUnitAdminRelayEntriesTeamsWrite = () => {
    const { state, gridState, omeMeetOrgUnitAthleteEntryRelayRosterEntryState, athleteMeetEventState,
        omeMeetOrgUnitAthleteEntryState, onAddRelayTeamClicked, onEditRelayTeamClicked, onDeleteRelayTeamClicked, onDeleteRelayTeam,
        modalState, onModalCanceled, omeMeetState, MAX_RELAY_TEAM_ENTRIES_PER_EVENT } = useOrgUnitAdminRelayEntriesTeams();

    return (
        <Fragment>
            <div className="row">
                <div className="col-xs-12">
                    <p className={global.HeaderText}><b>Relay Event:</b> {state.event?.eventName || ''} ({state.event?.eventCompetitionGenderTypeName || ''}, {state.event?.ageGroupName || ''}), Session {state.event?.meetSessionName || ''}</p>
                    {/* {(state.event?.timeCuts && state.event?.timeCuts.length > 0) &&
                        <p className={global.HeaderText}><b>Qualifying Time:</b>
                            {state.event.timeCuts.map((timeCut) => {
                                return (
                                    <Fragment key={timeCut.qualifyingEventId}>&nbsp;<span>{`(${timeCut.eventName || ''}`}{timeCut?.noFasterThanTimeCut ? ' No Faster Than ' + formatTimeForDisplay(timeCut?.noFasterThanTimeCut) : ''}{timeCut?.noFasterThanTimeCut && timeCut?.noSlowerThanTimeCut ? ' &' : ''}{timeCut?.noSlowerThanTimeCut ? ' No Slower Than ' + formatTimeForDisplay(timeCut?.noSlowerThanTimeCut) : ''}{`)`}</span></Fragment>
                                );
                            })}
                        </p>} */}
                </div>
            </div>
            {((gridState.gridData?.relayTeams && gridState.gridData?.relayTeams?.length < (omeMeetState.objData.omeMeetEligibility[0]?.maxRelayTeamEntriesPerEvent ? ToIntIfInt(omeMeetState.objData.omeMeetEligibility[0]?.maxRelayTeamEntriesPerEvent) : MAX_RELAY_TEAM_ENTRIES_PER_EVENT)) || !gridState.gridData?.relayTeams) &&
                <div className="row usas-extra-top-margin">
                    <div className="col-xs-12">
                        <ActionIntraPageButton onClick={onAddRelayTeamClicked}>Add Relay Team</ActionIntraPageButton>
                    </div>
                </div>}
            <div className="row">
                <div className="col-xs-12">
                    <OrgUnitAdminRelayEntriesTeamsGrid
                        gridData={gridState.gridData}
                        isLoading={omeMeetOrgUnitAthleteEntryRelayRosterEntryState.isArrayLoading}
                        onEditRelayTeamClicked={onEditRelayTeamClicked}
                        onDeleteRelayTeamClicked={onDeleteRelayTeamClicked}
                        state={state}
                    />
                </div>
            </div>
            <PopUpModal
                widthPct={90}
                maxWidth={720}
                title={modalState.modalTitle}
                displayPopUp={modalState.displayPopUp}
                onModalCanceled={onModalCanceled}>
                <div className="row">
                    <div className='col-xs-12'>
                        <p><strong>Team:</strong> {modalState?.relayTeamName}</p>
                        <p><strong>Entry Time:</strong> {modalState?.entryTime} {modalState?.entryTime !== 'NT' ? modalState?.courseCode : ''}</p>
                        <p><strong>Time Event:</strong> {modalState.timeEvent || ''}</p>
                        <p><strong>Aggregate?</strong> {modalState?.isAggregate}</p>
                        <p><strong>Override?</strong> {modalState?.swimTimeEntryOverride}</p>
                        <p><strong>Status:</strong> {modalState?.status}</p>
                    </div>
                    <div className="col-xs-12 usas-extra-top-margin">
                        <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>&nbsp;
                        <PrimaryButton type="button" onClick={(e) => onDeleteRelayTeam(e, modalState.relayMeetEventEntryId)}>Delete</PrimaryButton>
                    </div>
                </div>
            </PopUpModal>
            <PopUpModal
                widthPct={30}
                maxWidth={250}
                title={Constants.LOADING_MSG}
                displayPopUp={omeMeetOrgUnitAthleteEntryRelayRosterEntryState.isArrayLoading || omeMeetOrgUnitAthleteEntryState.isArrayLoading} />
            <PopUpModal
                widthPct={30}
                maxWidth={250}
                title={Constants.SAVING_MSG}
                displayPopUp={omeMeetOrgUnitAthleteEntryRelayRosterEntryState.isSaving || athleteMeetEventState.isSaving} />
        </Fragment>
    )
}
export default OrgUnitAdminRelayEntriesTeamsWrite;